import { DatePipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TimePeriod } from 'ngx-daterangepicker-material/daterangepicker.component';

import { Subscription } from 'rxjs';
import { ServicecallService } from 'src/app';
import { DataService } from 'src/app/services/data.service';
import { GeneralService } from 'src/app/services/general.service';
import { EntitiesServiceService } from '../../../../../services/entities-service.service';

@Component({
  selector: 'app-route',
  templateUrl: './route.component.html',
  styleUrls: ['./route.component.css']
})
export class RouteComponent implements OnInit, OnDestroy {

  @Input() entityId: any;
  @Input() widgetCount: number;
  @Input() fromDate: string;
  @Input() toDate: string;

  popRoute: boolean = false;
  masterMapData: any = [];
  datePicker = new FormControl(new Date());
  maxDate: Date = new Date();
  minDate: Date = this._generalService.getPreviousDateByType('day', 7);
  selectedDate: Date;
  showControls: boolean = false;
  dialogRef: any;

  private _routeData: any;
  private _isloader: boolean = false;
  private _tenantConfig: any;
  private _getEntityDetailsSubscription: Subscription;
  private _getGeoHistorySubscription: Subscription;


  constructor(
    private _service: EntitiesServiceService,
    public _dialog: MatDialog,
    private _generalService: GeneralService,
    private _dataService: DataService,
    private _datePipe: DatePipe,
    public sharedService: ServicecallService,
    private _fb: FormBuilder,
    private route: Router
  ) { }

  ngOnInit(): void {
    // this.getRouteData();
    this.getGeoHistory();
  }

  ngOnChanges(change: SimpleChanges) {
    if(change['fromDate'] && change['toDate']) {
      this.getGeoHistory();
    }
  }

  ngOnDestroy(): void {
    this._getEntityDetailsSubscription?.unsubscribe();
    this._getGeoHistorySubscription?.unsubscribe();
  }


  /**
   * Gets geo history
   */
  getGeoHistory() {
    let configStartDate = null;
    let configEndDate = null;
    this._tenantConfig = this.sharedService?.getConfiguration('tenantGenericConfig') ? this.sharedService?.getConfiguration('tenantGenericConfig') : null;

    if (this._tenantConfig?.defaultTimeRange) {
      const configHour = this._tenantConfig?.defaultTimeRange || 0;

      const { startDate, endDate } = this.sharedService.calculateDateRange(configHour);
      configEndDate = endDate;
      configStartDate = startDate;
    }
    const [startTime, endTime] = this.selectedDate ? this._generalService?.getStartEndTimeForSelectedDate(this.selectedDate, this._tenantConfig?.tenant, this._tenantConfig?.defaultTimeRange) : this._generalService?.getStartEndTimeByDate();
    const _reqPayload = {
      entityId: this.entityId,
      from: this._datePipe.transform(this.fromDate ?? ((!this.selectedDate && configStartDate) ? configStartDate : startTime), 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(this.toDate ?? ((!this.selectedDate && configEndDate) ? configEndDate : endTime), 'yyyy-MM-ddTHH:mm:ssZZ'),
    };
    this._getGeoHistorySubscription = this._service
      .getGeoHistory(_reqPayload)
      .subscribe((result: any) => {
        if (result.length) {
          const coordArray = result.map((data: any) => [
            data?.coordinates?.lat,
            data?.coordinates?.long,
          ]);
          this.masterMapData = [
            {
              polygonData: coordArray,
            },
          ];
        } else {
          this.masterMapData = [];
        }
      });
  }

  /**
   * Opens modal
   * @param templateRef 
   */
  openModal(templateRef) {
    this.dialogRef = this._dialog.open(templateRef, {
      maxWidth: '88vw',
      width: '88%',
      panelClass: 'route-popOver',
    });
    this.popRoute = !this.popRoute;
    this.dialogRef.afterClosed().subscribe(() => {
      this.popRoute = !this.popRoute;
      this.showControls = !this.showControls;
      this._dataService.broadcast('routePopOverClosed');
    });
  }

  /**
   * Dates change
   * @param event
   */
  dateChange(event: MatDatepickerInputEvent<Date>) {
    this.selectedDate = event?.value;
    this.getGeoHistory();
  }

  /**
   * Enables draw controls
   */
  enableDrawControls() {
    this.showControls = !this.showControls;
  }

  /**
   * Geos fence values
   * @param event 
   */
  geoFenceValues(event: []) {
    this._dataService.broadcast('zoneAdded', event);
  }

  /**
   * Gets route data
   */
  private _getRouteData() {
    this._getEntityDetailsSubscription = this._service
      .getEntityDetails({ entityId: this.entityId })
      .subscribe((result: any) => {
        if (result.status) {
          this._routeData = result?.response?.data[0];
          this._isloader = false;
        }
      });
  }

  public geoTracePlayback() {
    this.route.navigateByUrl(`/vehicles/profile/${this.entityId}/playback`);
  }

  public goToTripHistory() {
    this.popRoute = !this.popRoute;
    this.route.navigateByUrl(`/vehicles/profile/${this.entityId}/trip-history`);
  }

  get scalingClass(): number {
    return this.sharedService.getScalingFactor();
  }
}

